import { render, staticRenderFns } from "./reconfirmation.vue?vue&type=template&id=3a19ae20&scoped=true&"
import script from "./reconfirmation.vue?vue&type=script&lang=js&"
export * from "./reconfirmation.vue?vue&type=script&lang=js&"
import style0 from "./reconfirmation.vue?vue&type=style&index=0&id=3a19ae20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a19ae20",
  null
  
)

export default component.exports